import { createLazyComponent } from '@muse-web/router'

export const AsyncLinkAudacityDialogContainer = createLazyComponent(
    () => import(/* webpackChunkName: 'dialog-link-audacity' */ './LinkAudacityDialogContainer'),
    'LinkAudacityDialogContainer',
)
